enum RFPResponseStatus {
  OPEN = 'Open',
  IN_REVIEW = 'In Review',
  FINAL = 'Final',
}

export default RFPResponseStatus;
